import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import logger from 'conf/Logger';
import {useGet} from 'helpers/KyHooks';
import ClinicalAnnotationSection from 'pages/Statistics/ClinicalAnnotationSection';
import GuidelineSection from 'pages/Statistics/GuidelineSection';
import LabelSection from 'pages/Statistics/LabelSection';
import PathwaysSection from 'pages/Statistics/PathwaysSection';
import StatsGrid from 'pages/Statistics/StatsGrid';
import VariantAnnotationsSection from 'pages/Statistics/VariantAnnotationsSection';


export default function StatisticsPage() {

  const {response, error} = useGet('report/stats', {
    cacheResponse: false,
    parseJson: true,
  });
  if (error) {
    logger.error(error);
  }

  const handleSectionClick = (section) => {
    const elem = document.getElementById(section);
    elem.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <ReadableWidthTemplate title="Statistics">
      <StatsGrid data={response} onSectionClick={handleSectionClick} />

      <h2 className="mt-5">Type-Specific Statistics</h2>
      <div style={{display: 'grid', gridTemplateColumns: '1fr', gridGap: '4rem', marginTop: '4rem'}}>
        <GuidelineSection />
        <LabelSection />
        <PathwaysSection />
        <ClinicalAnnotationSection />
        <VariantAnnotationsSection />
      </div>
    </ReadableWidthTemplate>
  );
}
